import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import { Sidebar } from 'primereact/sidebar';

const HEADER_CELL_STYLE = { fontSize: '15px', fontWeight: 600 };
const BODY_CELL_STYLE = { fontSize: '13px', fontWeight: 500 };

const BillingView = ({ visible, billingData, getBillingStyle, getBillingStatusText, onHide }) => (
  <Sidebar
    style={{ width: '80%', borderBottom: '1px solid #ccc' }}
    dismissable={false}
    visible={visible}
    onHide={onHide}
    position="right"
  >
    <div>
      {billingData.length > 0 && (
        <>
          <div className="w-118 h-10 top-98 left-47 bg-lightBlue bg-opacity-5.5 overflow-auto">
            <Typography className="font-poppins text-base font-semibold leading-6 mt-2 ml-2 text-left">
              Enquiry Id - {billingData[0]?.serviceEnquiryId}
            </Typography>
          </div>
          <div className="w-118 h-10 top-98 left-47 bg-lightBlue bg-opacity-5.5 overflow-auto">
            <Typography className="font-poppins text-base font-semibold leading-6 mt-2 ml-2 text-left">
              Total Billing - {billingData[0]?.pagination?.totalRecords || 0}
            </Typography>
          </div>
          <TableContainer component={Paper} style={{ width: '100%', height: '36vw', overflowX: 'auto' }}>
            <Table>
              <TableHead>
                <TableRow>
                  {[
                    'Patient ID', 'Patient Name', 'Procedure Name', 'eClinic Name',
                    'Preferred Hospital & Clinic', 'DoctorName', 'Gross Amount',
                    'MCI', 'Net Sale', 'Total Amount', 'Billing Remark', 'Billing Status',
                  ].map((header) => (
                    <TableCell key={header} style={HEADER_CELL_STYLE}>{header}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {billingData.length > 0 ? (
                  billingData.map((item) => (
                    <TableRow key={item.id}>
                      <TableCell style={BODY_CELL_STYLE}>{item.patientId}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.patientName}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.procedureName}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.cheCenterName}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.hospitalName}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.referralUserName}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.gross}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.mci}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.yieldAmount}</TableCell>
                      <TableCell style={BODY_CELL_STYLE}>{item.totalAmount}</TableCell>
                      <TableCell style={{ ...BODY_CELL_STYLE, maxWidth: '150px' }}>
                        {item.billingRemark ? (
                          <Tooltip title={item.billingRemark} arrow placement="top">
                            <span
                              style={{
                                display: 'inline-block',
                                maxWidth: '150px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'middle',
                                cursor: 'pointer',
                              }}
                            >
                              {item.billingRemark}
                            </span>
                          </Tooltip>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell style={{ fontSize: '15px', fontWeight: 500 }}>
                        <span style={getBillingStyle(item.billingStatus)}>
                          {getBillingStatusText(item.billingStatus)}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={12} style={{ fontSize: '15px', fontWeight: 600 }}>
                      No records found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Divider />
          <div className="bg-white" />
        </>
      )}
    </div>
  </Sidebar>
);

BillingView.propTypes = {
  visible: PropTypes.bool.isRequired,
  billingData: PropTypes.arrayOf(
    PropTypes.shape({
      serviceEnquiryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      pagination: PropTypes.shape({
        totalRecords: PropTypes.number,
      }),
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      patientName: PropTypes.string,
      procedureName: PropTypes.string,
      cheCenterName: PropTypes.string,
      hospitalName: PropTypes.string,
      referralUserName: PropTypes.string,
      gross: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      mci: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      yieldAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      billingRemark: PropTypes.string,
      billingStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  getBillingStyle: PropTypes.func.isRequired,
  getBillingStatusText: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default BillingView;